import { render, staticRenderFns } from "./MonsterLink.vue?vue&type=template&id=74b4457c"
import script from "./MonsterLink.vue?vue&type=script&lang=js"
export * from "./MonsterLink.vue?vue&type=script&lang=js"
import style0 from "./MonsterLink.vue?vue&type=style&index=0&id=74b4457c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports